"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MakeErrorClass = exports.BaseError = void 0;
const make_error_1 = require("make-error");
const retry_1 = require("./retry");
const ignore_1 = require("./ignore");
/**
 * Base error class.
 */
class BaseError extends make_error_1.BaseError {
    /**
     * Initializes a new instance of the error.
     *
     * @param message Error message.
     * @param attrs Attributes to merge onto the instance.
     */
    constructor(message, attrs) {
        super(message);
        Object.assign(this, attrs);
    }
    /**
     * Preconfigures an `assert` function.
     *
     * @param message Error message.
     * @param attrs Attributes to merge onto the instance.
     *
     * @example
     *   promise.then(MyError.makeAssert('Stuff was not found'))
     */
    static makeAssert(message, attrs) {
        return (value) => {
            this.assert(value, message, attrs);
            return value;
        };
    }
    /**
     * If `data` is falsy, throws the error with the specified message.
     *
     * @param data The data to check.
     * @param message The message to construct the error with.
     * @param attrs Attributes to merge onto the instance.
     */
    static assert(data, message, attrs) {
        if (!data) {
            throw new this(typeof message === 'function' ? message() : message, attrs);
        }
    }
    /**
     * Retries the function until it does not throw the error type.
     * @param fn
     * @param opts
     */
    static retry(fn, opts) {
        return (0, retry_1.retry)((again, attempt) => {
            return Promise.resolve()
                .then(() => fn(attempt))
                .catch((err) => {
                if (err instanceof this) {
                    throw again(err);
                }
                throw err;
            });
        }, opts);
    }
    /**
     * Makes an ignore function for this error class that will return the specified value if caught.
     *
     * @param valueToReturnOnCatch
     */
    static ignore(valueToReturnOnCatch) {
        return (0, ignore_1.ignore)(this)(valueToReturnOnCatch);
    }
    /**
     * Default toJSON implementation.
     */
    toJSON() {
        const result = {
            stack: this.stack,
            message: this.message,
        };
        for (const prop in this) {
            const val = this[prop];
            if (typeof val !== 'function') {
                result[prop] = val;
            }
        }
        return result;
    }
}
exports.BaseError = BaseError;
/**
 * Makes a new error class preconfigured with the specified settings,
 * as well as some extra methods for assertions.
 *
 * @param defaultMessage The default error message.
 * @param defaultAttrs The default attributes for creating new instances.
 */
function MakeErrorClass(defaultMessage = 'An error occured', defaultAttrs) {
    class ConfiguredError extends BaseError {
        constructor(message, attrs) {
            message =
                // tslint:disable-next-line
                message === null || message === undefined ? defaultMessage : message;
            // istanbul ignore next: TS <-> Istanbul issue
            super(message, Object.assign({}, defaultAttrs, attrs));
        }
    }
    return ConfiguredError;
}
exports.MakeErrorClass = MakeErrorClass;
//# sourceMappingURL=make-error-class.js.map